import { formatDateToDash, getNumberOfDays } from "../../helpers/dateHelpers";
import { getPairingSpecialCredit } from "../../helpers/creditHelpers";

export const pairingPackageInitialFilter = () => {

	return {
		selectedRouteFilters: {
			numDays: { selected: ['All'] },
			landingIn: { selected: ['All'] },
			layoverIn: { selected: ['All'] },
			layoverDuration: { selected: [-1, -1] },
			fltNo: '',
			sectors: { selected: ['All'] },
			deadHeadFlight: true,
			redEyeFlights: true
		},
		selectedDateFilter: {
			dates: [],
			dateConditions: '1',
			onDuty: { selected: [-1, -1] },
			offDuty: { selected: [-1, -1] },
			tafb: { selected: [-1, -1] },
		},
		selectedCpeFilter: {
			expenses: {
				filter: "All",
				max: undefined,
				min: undefined,
				eq: undefined
			},
			credit: { selected: [-1, -1] },
			hoursPerDay: { selected: [-1, -1] },
			efficiency: { selected: [-1, -1] },
			dayCredit: { selected: [-1, -1] },
			nightCredit: { selected: [-1, -1] },
			dhCredit: { selected: [-1, -1] },
			oseas: { selected: [-1, -1] },
		},
		selectedOthersFilter: {
			occurs: { selected: ['All'] },
			pairType: { selected: ['All'] },
		},
	}
}

export const filterPairingPackageData = (pairingList, selectedFilters) => {
	if (!pairingList) {
		return [];
	}

	// Route Filters
	if (!selectedFilters.selectedRouteFilters.numDays.selected?.includes('All') && selectedFilters.selectedRouteFilters.numDays.selected?.length > 0) {
		pairingList = pairingList.filter(f => selectedFilters.selectedRouteFilters.numDays.selected.includes(f.days));
	}

	if (!selectedFilters.selectedRouteFilters.landingIn.selected?.includes('All') && selectedFilters.selectedRouteFilters.landingIn.selected?.length > 0) {
		pairingList = pairingList.filter(f => f.departLegs.some(dep => selectedFilters.selectedRouteFilters.landingIn.selected.includes(dep)));
	}
	
	if (!selectedFilters.selectedRouteFilters.layoverIn.selected?.includes('All') && selectedFilters.selectedRouteFilters.layoverIn.selected?.length > 0) {
		pairingList = pairingList.filter(f => f.flightSegments.some(fs => selectedFilters.selectedRouteFilters.layoverIn.selected.includes(fs?.layoverIn)));
	}

	if (!selectedFilters.selectedRouteFilters.sectors.selected?.includes('All') && selectedFilters.selectedRouteFilters.sectors.selected?.length > 0) {
		pairingList = pairingList.filter(f => selectedFilters.selectedRouteFilters.sectors.selected.includes(f.sectors));
	}

	// layOver duration
	if (!selectedFilters.selectedRouteFilters.layoverIn.selected?.includes('All') && selectedFilters.selectedRouteFilters.layoverIn.selected?.length > 0){
		pairingList = pairingList.filter(f => f.flightSegments.some(fs => {
			return fs.layOver >= selectedFilters.selectedRouteFilters.layoverDuration.selected[0] && fs.layOver <= selectedFilters.selectedRouteFilters.layoverDuration.selected[1] && selectedFilters.selectedRouteFilters.layoverIn.selected?.includes(fs?.layoverIn);
		}));
	} 
	else if (selectedFilters.selectedRouteFilters.layoverDuration.selected[0] !== -1 || selectedFilters.selectedRouteFilters.layoverDuration.selected[1] !== -1){
		pairingList = pairingList.filter(f => f.flightSegments.some(fs => {
			return fs.layOver >= selectedFilters.selectedRouteFilters.layoverDuration.selected[0] && fs.layOver <= selectedFilters.selectedRouteFilters.layoverDuration.selected[1];
		}));
	}

	if (selectedFilters.selectedRouteFilters.fltNo) {
		pairingList = pairingList.filter(p => p.flightSegments.filter(f => f.fltNo.replace(/\b0+/g, '')?.split(",").includes(selectedFilters.selectedRouteFilters.fltNo.replace(/\b0+/g, ''))).length);
	}

	if (!selectedFilters.selectedRouteFilters.redEyeFlights) {
		pairingList = pairingList.filter(v => getPairingSpecialCredit(v).value === 0);
	}

	if (!selectedFilters.selectedRouteFilters.deadHeadFlight) {
		pairingList = pairingList.filter(({ flightSegments }) => flightSegments.every(({ deadhead }) => deadhead === false));
	}

	// AppCalendar Filter
	let selectionTimes = selectedFilters.selectedDateFilter.dates.map(d => d.getTime());
	// doesn't opperate within dates 
	if (selectedFilters.selectedDateFilter.dateConditions === '1') {
		pairingList = pairingList.filter(f => f.pairingDates.some(a => {
			let s = new Date(`${a.start_date}T00:00:00`).getTime();
			let e = new Date(`${a.end_date}T00:00:00`).getTime();
			return selectionTimes.every((time) => !(time >= s && time <= e));
		}));
	}

	// starts on selected dates 
	if (selectedFilters.selectedDateFilter.dateConditions === '2') {
		pairingList = pairingList.filter(f => f.pairingDates.some(a => {
			let curr = new Date(`${a.start_date}T00:00:00`).getTime();
			return selectionTimes.includes(curr);
		}));
	}

	// departs and arrives on selected dates
	let selectedDates = selectedFilters.selectedDateFilter.dates.map(date => formatDateToDash(new Date(date))).sort((a,b) => new Date(a).getTime() - new Date(b).getTime());
	
	if (selectedFilters.selectedDateFilter.dateConditions === '3') {
		if(!selectedDates.length) return pairingList;
		pairingList = pairingList.filter(pairing =>
			pairing.pairingDates.some(pairingDate => {
				let actualDaysArr = getNumberOfDays(new Date(pairingDate?.start_date+" 00:00"), new Date(pairingDate?.end_date+" 00:00")).map(date => formatDateToDash(new Date(date+" 00:00"))).sort((a,b) => new Date(a).getTime() - new Date(b).getTime());
				let isEqual = selectedDates.join(',') === actualDaysArr.join(',');

				if(isEqual){
					return isEqual;
				}else{
					return actualDaysArr.every(day => selectedDates.includes(day));
				}
			})
		);
	}

	// starts on selected dates 
	if (selectedFilters.selectedDateFilter.dateConditions === '4') {
		pairingList = pairingList.filter(f => f.pairingDates.some(a => {
			let endDate = new Date(`${a.end_date}T00:00:00`).getTime();
			return selectionTimes.includes(endDate);
		}));
	}

	// Occurs on selected dates 
	if (selectedFilters.selectedDateFilter.dateConditions === '5') {
		if(!selectedDates.length) return pairingList;
		pairingList = pairingList.filter(pairing =>
			pairing.pairingDates.some(pairingDate => {
				let actualDaysArr = getNumberOfDays(new Date(pairingDate?.start_date+" 00:00"), new Date(pairingDate?.end_date+" 00:00")).map(date => formatDateToDash(new Date(date+" 00:00"))).sort((a,b) => new Date(a).getTime() - new Date(b).getTime());
				let isEqual = selectedDates.join(',') === actualDaysArr.join(',');

				if(isEqual){
					return isEqual;
				}else{
					return actualDaysArr.some(day => selectedDates.includes(day));
				}
			})
		);
	}

	/**
	 * Determine when selectedFilters are not at the default value to determine when to apply the change to the table in Pairing Package
	 */
	// on off tafb
	if (selectedFilters.selectedDateFilter.onDuty.selected[0] >= 0 || selectedFilters.selectedDateFilter.onDuty.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['onduty'] >= selectedFilters.selectedDateFilter.onDuty.selected[0] && f['onduty'] <= selectedFilters.selectedDateFilter.onDuty.selected[1]);
	}
	if (selectedFilters.selectedDateFilter.offDuty.selected[0] >= 0 || selectedFilters.selectedDateFilter.offDuty.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['offduty'] >= selectedFilters.selectedDateFilter.offDuty.selected[0] && f['offduty'] <= selectedFilters.selectedDateFilter.offDuty.selected[1]);
	}
	if (selectedFilters.selectedDateFilter.tafb.selected[0] >= 0 || selectedFilters.selectedDateFilter.tafb.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['tafb'] >= selectedFilters.selectedDateFilter.tafb.selected[0] && f['tafb'] <= selectedFilters.selectedDateFilter.tafb.selected[1]);
	}

	// CPE Filters	
	if (selectedFilters.selectedCpeFilter.credit.selected[0] >= 0 || selectedFilters.selectedCpeFilter.credit.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['credit'] >= selectedFilters.selectedCpeFilter.credit.selected[0] && f['credit'] <= selectedFilters.selectedCpeFilter.credit.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.hoursPerDay.selected[0] >= 0 || selectedFilters.selectedCpeFilter.hoursPerDay.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['hoursPerDay'] >= selectedFilters.selectedCpeFilter.hoursPerDay.selected[0] && f['hoursPerDay'] <= selectedFilters.selectedCpeFilter.hoursPerDay.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.efficiency.selected[0] >= 0 || selectedFilters.selectedCpeFilter.efficiency.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['eff'] >= selectedFilters.selectedCpeFilter.efficiency.selected[0] && f['eff'] <= selectedFilters.selectedCpeFilter.efficiency.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.dayCredit.selected[0] >= 0 || selectedFilters.selectedCpeFilter.dayCredit.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['daycredit'] >= selectedFilters.selectedCpeFilter.dayCredit.selected[0] && f['daycredit'] <= selectedFilters.selectedCpeFilter.dayCredit.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.nightCredit.selected[0] >= 0 || selectedFilters.selectedCpeFilter.nightCredit.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['nightcredit'] >= selectedFilters.selectedCpeFilter.nightCredit.selected[0] && f['nightcredit'] <= selectedFilters.selectedCpeFilter.nightCredit.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.dhCredit.selected[0] >= 0 || selectedFilters.selectedCpeFilter.dhCredit.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['dhCredit'] >= selectedFilters.selectedCpeFilter.dhCredit.selected[0] && f['dhCredit'] <= selectedFilters.selectedCpeFilter.dhCredit.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.oseas.selected[0] >= 0 || selectedFilters.selectedCpeFilter.oseas.selected[1] >= 0) {
		pairingList = pairingList.filter(f => f['overseasCredit'] >= selectedFilters.selectedCpeFilter.oseas.selected[0] && f['overseasCredit'] <= selectedFilters.selectedCpeFilter.oseas.selected[1]);
	}
	if (selectedFilters.selectedCpeFilter.expenses.filter !== 'All') {
		if (selectedFilters.selectedCpeFilter.expenses.filter === 'Range' && selectedFilters.selectedCpeFilter.expenses.min !== null && selectedFilters.selectedCpeFilter.expenses.max !== null) {
			pairingList = pairingList.filter(f => (f['expenses'] / 100) >= selectedFilters.selectedCpeFilter.expenses.min &&
				(f['expenses'] / 100) <= selectedFilters.selectedCpeFilter.expenses.max);
		}
		if (selectedFilters.selectedCpeFilter.expenses.filter === 'Eq' && selectedFilters.selectedCpeFilter.expenses.eq !== null) {
			pairingList = pairingList.filter(f => (f['expenses'] / 100) === selectedFilters.selectedCpeFilter.expenses.eq);
		}
	}

	// Others Filter
	if (!selectedFilters.selectedOthersFilter.occurs.selected?.includes('All') && selectedFilters.selectedOthersFilter.occurs.selected?.length > 0) {
		pairingList = pairingList.filter(f => selectedFilters.selectedOthersFilter.occurs.selected.includes(f.occurs));
	}
	if (!selectedFilters.selectedOthersFilter.pairType.selected?.includes('All') && selectedFilters.selectedOthersFilter.pairType.selected?.length > 0) {
		pairingList = pairingList.filter(f => selectedFilters.selectedOthersFilter.pairType.selected.includes(f.pairType));
	}

	return pairingList;
}